export default __webpack_public_path__ + "static/media/question-mark.8c70e992.svg";